/*
 * @Author: your name
 * @Date: 2020-09-29 13:14:43
 * @LastEditTime: 2021-03-09 11:11:38
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \project\src\main.js
 */
import Vue from "vue";
import App from "@/App";
import store from "@/store";
import router from "@/router";
import axios from "axios";
import "./assets/css/common.less";
// import './plugins/element.js'
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";

import VDistpicker from "v-distpicker";
import dayjs from "dayjs";
import VueQuillEditor from "vue-quill-editor";
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";
import echarts from "echarts";

// const ECharts =require('echarts')
// Vue.prototype.$echarts = ECharts;

//引入思源黑体
// import './assets/css/font.css'
// 引入进度条
import NProgress from "nprogress";
import "nprogress/nprogress.css";

Vue.prototype.$echarts = echarts;
Vue.use(ElementUI);
// 配置请求地址
axios.defaults.baseURL =
  process.env.NODE_ENV === "development" ? "/api" : process.env.VUE_APP_BASE_API;
// axios.defaults.baseURL = "/api";
// 超时时间
axios.defaults.timeout = 30000;
axios.defaults.headers = {
  "Content-Type": "application/json; charset=utf-8"
};
// 请求在到达服务器之前，先会调用use中的这个回调函数来添加请求头信息
axios.interceptors.request.use(config => {
  NProgress.start();
  //为请求头对象，添加token验证的token字段
  if (sessionStorage.getItem("token")) {
    config.headers.token = sessionStorage.getItem("token");
  }
  return config;
});
//response拦截器
axios.interceptors.response.use(config => {
  NProgress.done();
  return config;
});
Vue.prototype.$http = axios;
Vue.prototype.$dayjs = dayjs;

NProgress.configure({
  easing: "ease", // 动画方式
  speed: 500, // 递增进度条的速度
  showSpinner: false, // 是否显示加载ico
  trickleSpeed: 200, // 自动递增间隔
  minimum: 0.3 // 初始化时的最小百分比
});
//全局注册地区插件
Vue.component("v-distpicker", VDistpicker);

Vue.config.productionTip = false;
// 全局注册富文本编辑器
Vue.use(VueQuillEditor);
// 全局定义商安信网址变量
Vue.prototype.$saxurl = "http://81.68.197.101:8080";
// 全局定义商安信登录网址变量
Vue.prototype.$saxloginurl = "http://81.68.197.101:8088";
new Vue({
  store,
  router,
  render: h => h(App)
}).$mount("#app");
